import {
  InnerBlocks,
  useBlockProps,
  useInnerBlocksProps,
  InspectorControls,
  BlockControls,
} from '@wordpress/block-editor';

import {
  PanelBody,
  PanelRow,
  RangeControl,
  ToggleControl,
  Button,
  SelectControl,
  ToolbarGroup,
} from '@wordpress/components';

import { useState, useEffect } from '@wordpress/element';

import MediaPicker from '@components/ui/MediaPicker';
import ResponsiveImage from '@components/ui/ResponsiveImage';
import ResponsiveVideo from '@components/ui/ResponsiveVideo';

import { mediaPanel } from '@tailwind/media';
import LinkPicker from '@components/HelperControls/LinkPicker';
import BiteLinkPanel from '@components/DesignPanel/LinkPanel';

export default function Edit({ attributes, setAttributes, clientId }) {
  const {
    blockId,
    media,
    mediaStyle,
    mediaClass,
    linkUrl,
    linkTitle,
    linkTarget,
  } = attributes;

  useEffect(() => {
    if (!blockId) {
      setAttributes({ blockId: clientId });
    }
  }, []);

  const handleMedia = (media) => {
    setAttributes({
      media: media,
    });
  };

  const mediaStyleCallback = ({ currentStyle, currentClass }) => {
    setAttributes({
      mediaClass: currentClass,
      mediaStyle: currentStyle,
    });
  };
  // update attribute
  const linkCallback = (link) => {
    setAttributes({ ...link });
  };

  // set classes
  const blockProps = useBlockProps({
    className: `overflow-hidden bf_relative`,
  });

  return (
    <div {...blockProps}>
      <InspectorControls>
        <PanelBody title="Visual" initialOpen={true}>
          <MediaPicker
            title="Image"
            mediaProps={media}
            mediaCallback={(media) => handleMedia(media)}
          />
        </PanelBody>
        <PanelBody title={'Link'} initialOpen={false}>
          <BiteLinkPanel
            parentCallback={linkCallback}
            linkUrl={linkUrl}
            linkTitle={linkTitle}
            linkTarget={linkTarget}
            showLinkTile={false}
          />
        </PanelBody>
      </InspectorControls>
      <BlockControls group="other">
        <ToolbarGroup>
          <LinkPicker
            parentCallback={linkCallback}
            linkUrl={linkUrl}
            linkTitle={linkTitle}
            linkTarget={linkTarget}
            showLinkTile={false}
          />
        </ToolbarGroup>
      </BlockControls>
      {media.type === 'video' ? (
        <ResponsiveVideo
          media={media}
          mediaClass={mediaClass}
          key={`visual_video__${blockId}`}
        />
      ) : (
        <ResponsiveImage
          media={media}
          mediaClass={mediaClass}
          key={`visual_image__${blockId}`}
        />
      )}
      {linkUrl ? (
        <a
          rel="noopener noreferrer"
          target={linkTarget}
          href={linkUrl}
          title={linkTitle}
          className="pointer-events-none"
        ></a>
      ) : null}
    </div>
  );
}
